import ProgressPage from '../../components/layout/ProgressPage'
import ProgressBox from '../../components/user/ProgressBox'

const Progress = () => {
  return (
    <ProgressPage content={<ProgressBox />} hasGreeting={false} layout="none" />
  )
}

export default Progress
